import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ContrastFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ContrastFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M12 1C5.93 1 .99 5.93.99 12S5.93 23 12 23c6.07 0 11.01-4.93 11.01-11S18.07 1 12 1ZM3.99 12c0-4.41 3.59-8 8.01-8h.01v8L12 20c-4.42 0-8.01-3.59-8.01-8Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ContrastFilled;